<template>
  <div class="sixteen wide column">
    <div class="ui left floated basic button" style="margin-top:0.4em;" @click.once="backOneLevel">
      <i class="long arrow alternate left icon"></i>
      Back to Main
    </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {
		  backOneLevel(){

		    if (this.backToRoute() === '/lesson' || this.backToRoute() === '/action' ){
		      this.getProgramItems().then(()=>{
            this.$router.push({ path: this.backToRoute() });
          })
        }
        else if (this.backToRoute() === '/patient' ){
          this.getProgramPatients().then(()=>{
            this.$router.push({ path: this.backToRoute() });
          })
        }
        else {
          this.$router.push({ path: this.backToRoute() });
         }
      }
    }
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/NavDetailsTop.vue